import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { UploaddocumentService } from '../services/uploaddocument/uploaddocument.service';
import { ToastrService } from 'ngx-toastr';
import { Observable, BehaviorSubject, Subscription } from 'rxjs';
import { NgForm } from '@angular/forms';
import { RegistrationModel } from 'src/app/registrations-data/models/data/registration.model';
import { CodeDescriptionModel } from 'src/app/models/code-description.model';
import { Document } from 'src/app/models/document.model';
import { NewRegistrationDataCollectionService } from '../services/registration/newRegistration-data-collection.service';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-ir-uploaddocument',
    templateUrl: './ir-upload-document.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class IRUploaddocumentComponent implements OnInit {

    @Input() regForm: RegistrationModel;
    @Input() isEditable;
    @Input() isAOAMD = false;
    @Input() sectionName: string;

    // @Input() reason: [];
    file: File;
    fileName: string;
    documentType: string;
    comments: string;
    registrationSubject: BehaviorSubject<RegistrationModel> = new BehaviorSubject<RegistrationModel>(null);
    registration$: Observable<RegistrationModel> = this.registrationSubject.asObservable();
    transactionGuid: string;
    transactionGuid$ = this.dataCollectionSvc.selectedTransactionGUID$;
    documentTypes = [];
    subscription: Subscription;

    constructor(
        private toastrService: ToastrService,
        private uploaddocumentService: UploaddocumentService,
        private dataCollectionSvc: NewRegistrationDataCollectionService,
        private activatedRoute: ActivatedRoute) { }

    ngOnInit() {
        this.dataCollectionSvc.regFormObserv.subscribe(registration => {
            this.documentTypes = [];
            if (registration) {
                // this.registration = registration;
                this.registrationSubject.next(registration);
                // const reasons = registration.building.info.reason;
                // if (this.reason && !this.isAOAMD) {
                //     this.reason.forEach(reason => {
                if (registration.registrationSummary.reasons && !this.isAOAMD) {
                    registration.registrationSummary.reasons.forEach(reason => {
                        if (reason.code === 'Section421a16') {
                            this.documentTypes.push({
                                code: 'HPDworkbook',
                                description: 'HPD Work Book'
                            });
                        }
                        if (reason.code === 'RegulatoryAgreement') {
                            this.documentTypes.push({
                                code: 'RegulatoryAgreement',
                                description: 'Regulatory Agreement'
                            });
                        }
                    });
                }
                if (this.isAOAMD) {
                    this.documentTypes.push({
                        code: 'HpdDirective',
                        description: 'HPD Directive'
                    });
                    this.documentTypes.push({
                        code: 'CourtOrder',
                        description: 'Court Order'
                    });
                    this.documentTypes.push({
                        code: 'OraDirective',
                        description: 'Ora Directive'
                    });
                    this.documentTypes.push({
                        code: 'TpuDirective',
                        description: 'Tpu Directive'
                    });
                }
                if (this.documentTypes.length > 0 || this.isAOAMD) {
                    this.documentTypes.push({
                        code: 'GovernmentDirective',
                        description: 'Government Directive'
                    });
                    this.documentTypes.push({
                        code: 'HcrOrder',
                        description: 'HCR Order'
                    });
                    this.documentTypes.push({
                        code: 'CoverLetter',
                        description: 'Cover Letter'
                    });
                    this.documentTypes.push({
                        code: 'Other',
                        description: 'Other'
                    });
                }
            }
        });
        this.subscription = this.dataCollectionSvc.selectedTransactionGUID$.subscribe(transactionGuid => {
            this.transactionGuid = transactionGuid;
        });
    }

    fileChange(event) {
        const fileList: FileList = event.target.files;
        if (fileList.length > 0) {
            this.file = fileList[0];
            this.fileName = this.file.name;
        }
    }

    upload(form: NgForm) {
        this.uploaddocumentService.uploadDocument(this.activatedRoute.snapshot.params.registrationId, this.documentType, this.file,
            this.comments, this.sectionName).subscribe(response => {
                this.toastrService.success('Uploaded Document successfully', 'Document Uploaded');
                const documentObj: CodeDescriptionModel = new CodeDescriptionModel({
                    code: response.documentType.code,
                    description: response.documentType.description, shortName: response.documentType.shortName
                });
                // obj.description = this.documentTypes.filter(x => x.code === response.documentType)[0].description;
                const attachment: Document = {
                    documentType: documentObj,
                    otherDocumentType: this.comments ? this.comments : null,
                    documentDescription: this.comments ? this.comments : null,
                    documentId: response.documentId,
                    fileName: response.fileName,
                    sectionName: this.sectionName
                };
                this.regForm.documents.push(attachment);
                this.file = null;
                this.fileName = '';
                this.documentType = '';
                this.comments = '';
                // this.otherDocumentType = '';
                form.resetForm();
                this.dataCollectionSvc.sync(this.regForm, this.activatedRoute.snapshot.params.registrationId);
            });
    }
}
